module.exports = __webpack_public_path__ + "img/tabsview.71cd8b9d.png";